const admission = {
  // HeroSection
  'admission.hero.homeLink': 'ホーム',
  'admission.hero.currentPage': '入学案内',
  'admission.hero.imgAlt': '入学案内の資料を手に持ち丁寧に説明する執事の様子',

  // breadcrumb
  'admission.breadcrumb.home': 'ホーム',
  'admission.breadcrumb.current': '入学案内',

  // AdmissionFlow
  'admission.flow.label': 'ADMISSION FLOW',
  'admission.flow.title': 'ご入学までの流れ',
  'admission.flow.titleEn': 'Steps to Enrolment',
  'admission.flow.lead': '入学は、難しい手続きではありません。資料請求や個別相談から始め、ご納得のうえでお申込みいただけます。執事になるには、日本で執事を学ぶための執事学校の資料請求や個別相談から始めるのが安心です。',
  'admission.flow.optionalBadge': '任意',
  'admission.flow.requiredBadge': '必須',

  // GuideCards
  'admission.guide.label': 'NEXT STEPS',
  'admission.guide.title': 'ご状況に合わせてお進みください',
  'admission.guide.titleEn': 'Choose Your Path',
  'admission.guide.lead': '入学をご検討の段階に応じて、必要な情報へ直接アクセスいただけます。迷われたときは、個別相談が受け皿です。',
  'admission.guide.arrowLabel': '詳しく見る',

  // KeyPoints
  'admission.points.label': 'REQUIREMENTS',
  'admission.points.title': '募集要項の要点',
  'admission.points.titleEn': 'Key Admission Points',
  'admission.points.lead': '入学をご検討の際に、まずご確認いただきたい要点です。詳細については、応募資格ページをご覧ください。日本の執事学校では、執事養成学校としての課程と、修了後の執事資格についてもご確認いただけます。',
  'admission.points.contactNote': '詳細な条件や手続きについては',
  'admission.points.contactLink': '応募資格・申込の流れ',
  'admission.points.contactSuffix': 'をご確認ください',

  // ReassuranceSection
  'admission.reassure.label': 'COMMON CONCERNS',
  'admission.reassure.title': 'よくあるご不安にお答えします',
  'admission.reassure.titleEn': 'Your Questions, Answered',
  'admission.reassure.lead': '「未経験でも大丈夫だろうか」「仕事と両立できるだろうか」——よくいただくご不安に、先にお答えします。',
  'admission.reassure.imgCaption': '明るい雰囲気の教室で、未経験からでも安心して学べます',

  // FAQSection
  'admission.faq.label': 'FAQ',
  'admission.faq.title': 'よくあるご質問',
  'admission.faq.titleEn': 'Frequently Asked Questions',
  'admission.faq.contactNote': 'その他のご質問は',
  'admission.faq.contactLink': 'お問い合わせ',
  'admission.faq.contactSuffix': 'よりお寄せください',

  // CTASection
  'admission.cta.label': 'TAKE THE NEXT STEP',
  'admission.cta.title': 'ご状況に合わせて、次の一歩を',
  'admission.cta.lead': 'まずは資料で比較したい方、じっくり相談されたい方、すぐにお申込みされたい方。どの段階でも、迷わず進める導線をご用意しています。',
  'admission.cta.onlineNote': '※ご相談はオンラインでも承ります',
  'admission.cta.applyBtn': '申込フォームへ',
  'admission.cta.brochureBtn': '資料請求はこちら（無料）',
  'admission.cta.consultBtn': '個別相談を予約する',
  'admission.cta.corporateNote': '企業・団体でのご検討は',
  'admission.cta.corporateLink': '法人研修（出張型）へ',
  'admission.pdfDl.button': '資料請求後にダウンロード案内をメールでお送りします',

  // RelatedPages
  'admission.related.label': 'LEARN MORE',
  'admission.related.title': '関連ページ',
  'admission.related.titleEn': 'Explore Further',
  'admission.related.arrowLabel': '詳しく見る',

  // footer
  'admission.footer.lastUpdated': '最終更新: 2026年6月13日',
  'admission.backToTop.ariaLabel': 'ページの先頭へ戻る',
};

export default admission;
